import { useTheme } from '@mui/material';
import { memo } from 'react';

export interface DragGhostProps {
  name: string;
}

export const DragGhost = memo(function DragGhost({ name }: DragGhostProps) {
  const theme = useTheme();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 12px',
        background: theme.palette.common.white,
        border: `1px solid ${theme.palette.table.borderColor}`,
        borderRadius: 4,
        boxShadow:
          '0 6px 18px rgba(0,0,0,0.10), 0 2px 6px rgba(0,0,0,0.06), inset 0 0 0 1px rgba(0,0,0,0.02)',
        maxWidth: 350,
        willChange: 'transform',
        transform: 'translateZ(0)',
        backfaceVisibility: 'hidden',
        pointerEvents: 'none',
        userSelect: 'none',
        fontSize: 14,
        fontFamily: 'inherit',
        color: 'inherit',
      }}
      title={name || 'Untitled'}
    >
      <span
        style={{
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        {name || 'Untitled'}
      </span>
    </div>
  );
});
